import '@adornis/chemistry/elements/components/x-flex.js';
import { inputToken } from '@adornis/chemistry/elements/theming/input-token.js';
import { XCheckbox } from '@adornis/forms/x-checkbox.js';
import { customElement } from 'lit/decorators.js';
import './cr-icon.js';

/**
 * @customElement cr-checkbox
 */
@customElement('cr-checkbox')
export class ChromiumCheckbox extends XCheckbox {
  override get inputToken() {
    return inputToken(this);
  }

  constructor() {
    super();
    this.booleanOnly = true;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          color: this.hasAttribute('white') ? '#fff' : '',
        },
        '#circle': {
          borderRadius: '4px',
          border: `1px solid ${this.colors.white.shade(800)}`,
          width: '20px',
          height: '20px',
          color: this.colors.white.shade(800),
          transition: 'all .2s ease-in-out',
          background: this.colors.white.shade(500),
          // transform: this.value.value ? 'rotateZ(0deg)' : 'rotateZ(180deg)',
          fontSize: '1.6rem',
        },
      },
    ];
  }
}
